import { MapUtils } from '../../../utility/map-utils.js';
import { BusinessModuleRef } from '../business-module-ref.js';
import { SeatSelectionSerializer } from '../../../serialization/seat-selection-serializer.js';
import { ISeatSelectionEntry } from './seat-selection-entry.js';
import {
  DataModel, DataModelBuilder, SerializationContext, SerializedData,
  isSameData, isSameList, cloneListOfCloneable,
} from '../../dto/dto.js';

export class PassSeatSelectionLock extends DataModel {
  static readonly TYPE_ID: string = 'ade3aa178b604054a80b39067c9d5c29';

  constructor(
    public readonly businessRef: BusinessModuleRef,
    public readonly templateId: string,
    public readonly entries: ISeatSelectionEntry[],
  ) {
    super();
  }

  get $typeId(): string {
    return PassSeatSelectionLock.TYPE_ID;
  }

  static empty(businessRef: BusinessModuleRef, templateId: string): PassSeatSelectionLock {
    return new PassSeatSelectionLock(
        businessRef,
        templateId,
        []
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): PassSeatSelectionLock {
    return new PassSeatSelectionLock(
        BusinessModuleRef.mustDecode(MapUtils.get<string>(map, 'businessRef')),
        MapUtils.get<string>(map, 'templateId'),
        SeatSelectionSerializer.deserialize(context.fromBinaryBlob(MapUtils.getRaw(map, 'entries'))),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'businessRef': this.businessRef.encode(),
      'templateId': this.templateId,
      'entries': context.toBinaryBlob(SeatSelectionSerializer.serialize(this.entries)),
    };
  }

  clone(): this {
    return new PassSeatSelectionLock(
        this.businessRef.clone(),
        this.templateId,
        cloneListOfCloneable(this.entries),
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.templateId === this.templateId &&
          isSameList(other.entries, this.entries, isSameData) &&
          isSameData(other.businessRef, this.businessRef);
  }
}

export class PassSeatSelectionLockBuilder extends DataModelBuilder<PassSeatSelectionLock> {
  build(context: SerializationContext, map: SerializedData): PassSeatSelectionLock {
    return PassSeatSelectionLock.fromMap(context, map);
  }
}
